<template>
  <div
    ref="sidebarRef"
    :class="[
      'fixed sidebar-area backdrop-blur-xl bg-white dark:bg-[#0c1427]/95 z-[10000] top-0 h-screen rounded-r-[20px] shadow-2xl shadow-black/10 dark:shadow-black/30 border-r border-gray-200/50 dark:border-gray-700/50',
      { active: stateStoreInstance.open },
    ]"
  >
    <div
      class="logo backdrop-blur-xl bg-white dark:bg-[#0c1427]/95 border-b border-gray-200/60 dark:border-[#172036]/60 px-[28px] pt-[22px] pb-[18px] absolute z-[10001] right-0 top-0 left-0 shadow-sm"
    >
      <RouterLink
        to="/dashboard/crm"
        class="transition-all duration-300 relative flex items-center justify-center group"
      >
        <div class="relative">
          <img
            src="@/assets/images/logos/sidebarlogo.png"
            alt="logo"
            class="h-8 w-auto transition-all duration-300"
          />
        </div>
      </RouterLink>

    </div>
    <div
      class="h-[calc(100vh-92px)] mt-[92px] px-[20px] pb-[20px] overflow-y-auto custom-scrollbar"
    >
      <div class="accordion space-y-6" :key="`${locale.toString()}-${forceRerender}`">
        <div class="section-group">
          <div 
            class="section-content transition-all duration-300 ease-in-out overflow-hidden"
          >
          <div v-if="shouldShowEcommerceDashboard" class="nav-item-container">
            <RouterLink
              to="/dashboard"
              class="nav-item group flex items-center py-3 px-4 rounded-2xl font-medium w-full relative text-gray-700 dark:text-gray-300 hover:text-[#007AFF] dark:hover:text-[#007AFF] active:scale-[0.98]"
              @click="handleNavigation"
            >
              <div
                class="icon-wrapper w-9 h-9 rounded-xl flex items-center justify-center ltr:mr-3 rtl:ml-3"
                style="background: linear-gradient(135deg, #007aff 0%, #5856d6 100%)"
              >
                <i
                  class="ri-shopping-cart-line text-[20px] transition-all duration-300 group-hover:scale-110"
                  style="color: #ffffff; text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2)"
                ></i>
              </div>
              <span class="title font-medium">{{ directT("sidebar.ecommerce") }}</span>
              <div
                class="ltr:ml-auto rtl:mr-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300"
              >
                <div class="w-1.5 h-1.5 rounded-full bg-[#007AFF]"></div>
              </div>
            </RouterLink>
          </div>
          <div v-if="shouldShowCRMDashboard" class="nav-item-container">
            <RouterLink
              to="/dashboard/crm"
              class="nav-item group flex items-center py-3 px-4 rounded-2xl font-medium w-full relative text-gray-700 dark:text-gray-300 hover:text-[#007AFF] dark:hover:text-[#007AFF] active:scale-[0.98]"
              @click="handleNavigation"
            >
              <div
                class="icon-wrapper w-9 h-9 rounded-xl flex items-center justify-center ltr:mr-3 rtl:ml-3"
                style="background: linear-gradient(135deg, #007aff 0%, #5856d6 100%)"
              >
                <i
                  class="ri-team-line text-[20px] transition-all duration-300 group-hover:scale-110"
                  style="color: #ffffff; text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2)"
                ></i>
              </div>
              <span class="title font-medium">{{ directT("sidebar.dashboard") }}</span>
              <div
                class="ltr:ml-auto rtl:mr-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300"
              >
                <div class="w-1.5 h-1.5 rounded-full bg-[#007AFF]"></div>
              </div>
            </RouterLink>
          </div>
          </div>
        </div>
        <div class="section-group">
          <div 
            class="section-header flex items-center mb-4 px-2 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800/50 rounded-lg py-2 transition-colors duration-200"
            @click="toggleSectionCollapse('apps')"
          >
            <div
              class="w-1 h-4 rounded-full ltr:mr-3 rtl:ml-3"
              style="background: linear-gradient(to bottom, #34c759 0%, #30d158 100%)"
            ></div>
            <span
              class="font-semibold uppercase text-[11px] tracking-wider"
              style="color: #6b7280"
            >
              {{ directT("sidebar.apps") }}
            </span>
          </div>
          <div 
            class="section-content space-y-2 transition-all duration-300 ease-in-out overflow-hidden"
            :class="{ 'collapsed': sectionCollapsed.apps }"
          >
            <div class="nav-item-container">
              <RouterLink
                to="/apps/to-do-list"
                class="nav-item group flex items-center py-3 px-4 rounded-2xl font-medium w-full relative text-gray-700 dark:text-gray-300 hover:text-[#34C759] dark:hover:text-[#34C759] active:scale-[0.98]"
                @click="handleNavigation"
              >
                <div
                  class="icon-wrapper w-9 h-9 rounded-xl flex items-center justify-center ltr:mr-3 rtl:ml-3"
                  style="background: linear-gradient(135deg, #34c759 0%, #30d158 100%)"
                >
                  <i
                    class="ri-checkbox-circle-line text-[20px] transition-all duration-300 group-hover:scale-110"
                    style="color: #ffffff; text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2)"
                  ></i>
                </div>
                <span class="title font-medium">{{ directT("sidebar.todoList") }}</span>
                <div
                  class="ltr:ml-auto rtl:mr-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                >
                  <div class="w-1.5 h-1.5 rounded-full bg-[#34C759]"></div>
                </div>
              </RouterLink>
            </div>
            <div class="nav-item-container">
              <RouterLink
                to="/apps/calendar"
                class="nav-item group flex items-center py-3 px-4 rounded-2xl font-medium w-full relative text-gray-700 dark:text-gray-300 hover:text-[#34C759] dark:hover:text-[#34C759] active:scale-[0.98]"
                @click="handleNavigation"
              >
                <div
                  class="icon-wrapper w-9 h-9 rounded-xl flex items-center justify-center ltr:mr-3 rtl:ml-3"
                  style="background: linear-gradient(135deg, #34c759 0%, #30d158 100%)"
                >
                  <i
                    class="ri-calendar-event-line text-[20px] transition-all duration-300 group-hover:scale-110"
                    style="color: #ffffff; text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2)"
                  ></i>
                </div>
                <span class="title font-medium">{{ directT("sidebar.calendar") }}</span>
                <div
                  class="ltr:ml-auto rtl:mr-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                >
                  <div class="w-1.5 h-1.5 rounded-full bg-[#34C759]"></div>
                </div>
              </RouterLink>
            </div>

            <div class="nav-item-container">
              <RouterLink
                to="/apps/chat"
                class="nav-item group flex items-center py-3 px-4 rounded-2xl font-medium w-full relative text-gray-700 dark:text-gray-300 hover:text-[#34C759] dark:hover:text-[#34C759] active:scale-[0.98]"
                @click="handleNavigation"
              >
                <div
                  class="icon-wrapper w-9 h-9 rounded-xl flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3"
                  style="
                    background: linear-gradient(135deg, #34c759 0%, #30d158 100%);
                    box-shadow: 0 8px 32px rgba(52, 199, 89, 0.3),
                      inset 0 1px 0 rgba(255, 255, 255, 0.2);
                  "
                >
                  <i
                    class="ri-message-3-line text-[20px] transition-all duration-300 group-hover:scale-110"
                    style="color: #ffffff; text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2)"
                  ></i>
                </div>
                <span class="title font-medium">{{ directT("sidebar.chat") }}</span>
                <div
                  class="ltr:ml-auto rtl:mr-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                >
                  <div class="w-1.5 h-1.5 rounded-full bg-[#34C759]"></div>
                </div>
              </RouterLink>
            </div>
            <div class="nav-item-container">
              <RouterLink
                to="/apps/contacts"
                class="nav-item group flex items-center py-3 px-4 rounded-2xl font-medium w-full relative text-gray-700 dark:text-gray-300 hover:text-[#34C759] dark:hover:text-[#34C759] active:scale-[0.98]"
                @click="handleNavigation"
              >
                <div
                  class="icon-wrapper w-9 h-9 rounded-xl flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3"
                  style="
                    background: linear-gradient(135deg, #34c759 0%, #30d158 100%);
                    box-shadow: 0 8px 32px rgba(52, 199, 89, 0.3),
                      inset 0 1px 0 rgba(255, 255, 255, 0.2);
                  "
                >
                  <i
                    class="ri-user-heart-line text-[20px] transition-all duration-300 group-hover:scale-110"
                    style="color: #ffffff; text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2)"
                  ></i>
                </div>
                <span class="title font-medium">{{ directT("sidebar.contacts") }}</span>
                <div
                  class="ltr:ml-auto rtl:mr-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                >
                  <div class="w-1.5 h-1.5 rounded-full bg-[#34C759]"></div>
                </div>
              </RouterLink>
            </div>
          </div>
        </div>
        <div class="section-group">
          <div 
            class="section-header flex items-center mb-4 px-2 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800/50 rounded-lg py-2 transition-colors duration-200"
            @click="toggleSectionCollapse('aiAgents')"
          >
            <div
              class="w-1 h-4 rounded-full ltr:mr-3 rtl:ml-3"
              style="background: linear-gradient(to bottom, #ff3b30 0%, #ff9500 100%)"
            ></div>
            <span
              class="font-semibold uppercase text-[11px] tracking-wider"
              style="color: #6b7280"
            >
              {{ directT("sidebar.aiAgents") }}
            </span>
          </div>
          <div 
            class="section-content transition-all duration-300 ease-in-out overflow-hidden"
            :class="{ 'collapsed': sectionCollapsed.aiAgents }"
          >
          <div class="nav-item-container">
            <RouterLink
              to="/bots"
              class="nav-item group flex items-center py-3 px-4 rounded-2xl font-medium w-full relative text-gray-700 dark:text-gray-300 hover:text-[#FF3B30] dark:hover:text-[#FF3B30] hover:bg-gradient-to-r hover:from-[#FF3B30]/8 hover:to-[#FF9500]/8 dark:hover:from-[#FF3B30]/12 dark:hover:to-[#FF9500]/12 hover: hover:shadow-[#FF3B30]/10 active:scale-[0.98]"
              @click="handleNavigation"
            >
              <div
                class="icon-wrapper w-9 h-9 rounded-xl flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3"
                style="
                  background: linear-gradient(135deg, #ff3b30 0%, #ff9500 100%);
                  box-shadow: 0 8px 32px rgba(255, 59, 48, 0.3),
                    inset 0 1px 0 rgba(255, 255, 255, 0.2);
                "
              >
                <i
                  class="ri-brain-line text-[20px] transition-all duration-300 group-hover:scale-110"
                  style="color: #ffffff; text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2)"
                ></i>
              </div>
              <span class="title font-medium">{{ directT("sidebar.myAgents") }}</span>
              <div
                class="ltr:ml-auto rtl:mr-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300"
              >
                <div class="w-1.5 h-1.5 rounded-full bg-[#FF3B30]"></div>
              </div>
            </RouterLink>
          </div>
          </div>
        </div>
        <div class="section-group">
          <div 
            class="section-header flex items-center mb-4 px-2 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800/50 rounded-lg py-2 transition-colors duration-200"
            @click="toggleSectionCollapse('pages')"
          >
            <div
              class="w-1 h-4 rounded-full ltr:mr-3 rtl:ml-3"
              style="background: linear-gradient(to bottom, #5856d6 0%, #af52de 100%)"
            ></div>
            <span
              class="font-semibold uppercase text-[11px] tracking-wider"
              style="color: #6b7280"
            >
              {{ directT("sidebar.pages") }}
            </span>
          </div>
          <div 
            class="section-content space-y-2 transition-all duration-300 ease-in-out overflow-hidden"
            :class="{ 'collapsed': sectionCollapsed.pages }"
          >
            <div v-if="shouldShowEcommerceMenu" class="nav-item-container">
              <button
                class="nav-item toggle group flex items-center py-3 px-4 rounded-2xl font-medium w-full relative text-gray-700 dark:text-gray-300 hover:text-[#5856D6] dark:hover:text-[#5856D6] hover:bg-gradient-to-r hover:from-[#5856D6]/8 hover:to-[#AF52DE]/8 dark:hover:from-[#5856D6]/12 dark:hover:to-[#AF52DE]/12 hover: hover:shadow-[#5856D6]/10 active:scale-[0.98]"
                type="button"
              >
                <div
                  class="icon-wrapper w-9 h-9 rounded-xl flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3"
                  style="
                    background: linear-gradient(135deg, #5856d6 0%, #af52de 100%);
                    box-shadow: 0 8px 32px rgba(88, 86, 214, 0.3),
                      inset 0 1px 0 rgba(255, 255, 255, 0.2);
                  "
                >
                  <i
                    class="ri-store-3-line text-[20px] transition-all duration-300 group-hover:scale-110"
                    style="color: #ffffff; text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2)"
                  ></i>
                </div>
                <span class="title font-medium">{{ directT("sidebar.ecommerce") }}</span>
                <i
                  class="ri-arrow-down-s-line text-[16px] ltr:ml-auto rtl:mr-auto transition-transform duration-300 group-hover:text-[#5856D6]"
                  style="color: #9ca3af"
                ></i>
              </button>
              <div class="accordion-collapse hidden mt-2 ltr:ml-12 rtl:mr-12 space-y-1">
                <div class="sidemenu-item">
                  <RouterLink
                    to="/ecommerce/products-grid"
                    class="submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#5856D6] dark:hover:text-[#5856D6] hover:bg-gradient-to-r hover:from-[#5856D6]/6 hover:to-[#AF52DE]/6 dark:hover:from-[#5856D6]/10 dark:hover:to-[#AF52DE]/10 active:scale-[0.98]"
                    @click="handleNavigation"
                  >
                    <div
                      class="w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3"
                      style="
                        background: linear-gradient(135deg, #5856d6 0%, #af52de 100%);
                      "
                    >
                      <i
                        class="ri-grid-line text-[14px] transition-all duration-300"
                        style="color: #ffffff"
                      ></i>
                    </div>
                    <span class="text-sm">{{ directT("sidebar.productsGrid") }}</span>
                  </RouterLink>
                </div>
                <div class="sidemenu-item">
                  <RouterLink
                    to="/ecommerce/products-list"
                    class="submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#5856D6] dark:hover:text-[#5856D6] hover:bg-gradient-to-r hover:from-[#5856D6]/6 hover:to-[#AF52DE]/6 dark:hover:from-[#5856D6]/10 dark:hover:to-[#AF52DE]/10 active:scale-[0.98]"
                    @click="handleNavigation"
                  >
                    <div
                      class="w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3"
                      style="
                        background: linear-gradient(135deg, #5856d6 0%, #af52de 100%);
                      "
                    >
                      <i
                        class="ri-list-check text-[14px] transition-all duration-300"
                        style="color: #ffffff"
                      ></i>
                    </div>
                    <span class="text-sm">{{ directT("sidebar.productsList") }}</span>
                  </RouterLink>
                </div>
                <div class="sidemenu-item">
                  <RouterLink
                    to="/crm/customers"
                    class="submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#5856D6] dark:hover:text-[#5856D6] hover:bg-gradient-to-r hover:from-[#5856D6]/6 hover:to-[#AF52DE]/6 dark:hover:from-[#5856D6]/10 dark:hover:to-[#AF52DE]/10 active:scale-[0.98]"
                    @click="handleNavigation"
                  >
                    <div
                      class="w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3"
                      style="
                        background: linear-gradient(135deg, #5856d6 0%, #af52de 100%);
                      "
                    >
                      <i
                        class="ri-user-line text-[14px] transition-all duration-300"
                        style="color: #ffffff"
                      ></i>
                    </div>
                    <span class="text-sm">{{ directT("sidebar.customers") }}</span>
                  </RouterLink>
                </div>
                <div class="sidemenu-item">
                  <RouterLink
                    to="/ecommerce/orders"
                    class="submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#5856D6] dark:hover:text-[#5856D6] hover:bg-gradient-to-r hover:from-[#5856D6]/6 hover:to-[#AF52DE]/6 dark:hover:from-[#5856D6]/10 dark:hover:to-[#AF52DE]/10 active:scale-[0.98]"
                    @click="handleNavigation"
                  >
                    <div
                      class="w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3"
                      style="
                        background: linear-gradient(135deg, #5856d6 0%, #af52de 100%);
                      "
                    >
                      <i
                        class="ri-shopping-bag-line text-[14px] transition-all duration-300"
                        style="color: #ffffff"
                      ></i>
                    </div>
                    <span class="text-sm">{{ directT("sidebar.orders") }}</span>
                  </RouterLink>
                </div>
              </div>
            </div>
            <div v-if="shouldShowCRMMenu" class="nav-item-container">
              <button
                class="nav-item toggle group flex items-center py-3 px-4 rounded-2xl font-medium w-full relative text-gray-700 dark:text-gray-300 hover:text-[#5856D6] dark:hover:text-[#5856D6] hover:bg-gradient-to-r hover:from-[#5856D6]/8 hover:to-[#AF52DE]/8 dark:hover:from-[#5856D6]/12 dark:hover:to-[#AF52DE]/12 hover: hover:shadow-[#5856D6]/10 active:scale-[0.98]"
                type="button"
              >
                <div
                  class="icon-wrapper w-9 h-9 rounded-xl flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3"
                  style="
                    background: linear-gradient(135deg, #5856d6 0%, #af52de 100%);
                    box-shadow: 0 8px 32px rgba(88, 86, 214, 0.3),
                      inset 0 1px 0 rgba(255, 255, 255, 0.2);
                  "
                >
                  <i
                    class="ri-user-settings-line text-[20px] transition-all duration-300 group-hover:scale-110"
                    style="color: #ffffff; text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2)"
                  ></i>
                </div>
                <span class="title font-medium">{{ directT("sidebar.crm") }}</span>
                <i
                  class="ri-arrow-down-s-line text-[16px] ltr:ml-auto rtl:mr-auto transition-transform duration-300 group-hover:text-[#5856D6]"
                  style="color: #9ca3af"
                ></i>
              </button>
              <div class="accordion-collapse hidden mt-2 ltr:ml-12 rtl:mr-12 space-y-1">
                <div class="sidemenu-item">
                  <RouterLink
                    to="/crm/leads"
                    class="submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#5856D6] dark:hover:text-[#5856D6] hover:bg-gradient-to-r hover:from-[#5856D6]/6 hover:to-[#AF52DE]/6 dark:hover:from-[#5856D6]/10 dark:hover:to-[#AF52DE]/10 active:scale-[0.98]"
                    @click="handleNavigation"
                  >
                    <div
                      class="w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3"
                      style="
                        background: linear-gradient(135deg, #5856d6 0%, #af52de 100%);
                      "
                    >
                      <i
                        class="ri-user-add-line text-[14px] transition-all duration-300"
                        style="color: #ffffff"
                      ></i>
                    </div>
                    <span class="text-sm">{{ directT("sidebar.leads") }}</span>
                  </RouterLink>
                </div>

                <div class="sidemenu-item">
                  <RouterLink
                    to="/crm/customers"
                    class="submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#5856D6] dark:hover:text-[#5856D6] hover:bg-gradient-to-r hover:from-[#5856D6]/6 hover:to-[#AF52DE]/6 dark:hover:from-[#5856D6]/10 dark:hover:to-[#AF52DE]/10 active:scale-[0.98]"
                    @click="handleNavigation"
                  >
                    <div
                      class="w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3"
                      style="
                        background: linear-gradient(135deg, #5856d6 0%, #af52de 100%);
                      "
                    >
                      <i
                        class="ri-team-line text-[14px] transition-all duration-300"
                        style="color: #ffffff"
                      ></i>
                    </div>
                    <span class="text-sm">{{ directT("sidebar.customers") }}</span>
                  </RouterLink>
                </div>
                <div class="sidemenu-item">
                  <RouterLink
                    to="/crm/deals"
                    class="submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#5856D6] dark:hover:text-[#5856D6] hover:bg-gradient-to-r hover:from-[#5856D6]/6 hover:to-[#AF52DE]/6 dark:hover:from-[#5856D6]/10 dark:hover:to-[#AF52DE]/10 active:scale-[0.98]"
                    @click="handleNavigation"
                  >
                    <div
                      class="w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3"
                      style="
                        background: linear-gradient(135deg, #5856d6 0%, #af52de 100%);
                      "
                    >
                      <i
                        class="ri-briefcase-line text-[14px] transition-all duration-300"
                        style="color: #ffffff"
                      ></i>
                    </div>
                    <span class="text-sm">{{ directT("sidebar.deals") }}</span>
                  </RouterLink>
                </div>
                <div class="sidemenu-item">
                  <RouterLink
                    to="/ecommerce/products-grid"
                    class="submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#5856D6] dark:hover:text-[#5856D6] hover:bg-gradient-to-r hover:from-[#5856D6]/6 hover:to-[#AF52DE]/6 dark:hover:from-[#5856D6]/10 dark:hover:to-[#AF52DE]/10 active:scale-[0.98]"
                    @click="handleNavigation"
                  >
                    <div
                      class="w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3"
                      style="
                        background: linear-gradient(135deg, #5856d6 0%, #af52de 100%);
                      "
                    >
                      <i
                        class="ri-grid-line text-[14px] transition-all duration-300"
                        style="color: #ffffff"
                      ></i>
                    </div>
                    <span class="text-sm">{{ directT("sidebar.productsGrid") }}</span>
                  </RouterLink>
                </div>
                <div class="sidemenu-item">
                  <RouterLink
                    to="/ecommerce/products-list"
                    class="submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#5856D6] dark:hover:text-[#5856D6] hover:bg-gradient-to-r hover:from-[#5856D6]/6 hover:to-[#AF52DE]/6 dark:hover:from-[#5856D6]/10 dark:hover:to-[#AF52DE]/10 active:scale-[0.98]"
                    @click="handleNavigation"
                  >
                    <div
                      class="w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3"
                      style="
                        background: linear-gradient(135deg, #5856d6 0%, #af52de 100%);
                      "
                    >
                      <i
                        class="ri-list-check text-[14px] transition-all duration-300"
                        style="color: #ffffff"
                      ></i>
                    </div>
                    <span class="text-sm">{{ directT("sidebar.productsList") }}</span>
                  </RouterLink>
                </div>
              </div>
            </div>
            <div v-if="shouldShowRealEstateMenu" class="nav-item-container">
              <button
                class="nav-item toggle group flex items-center py-3 px-4 rounded-2xl font-medium w-full relative text-gray-700 dark:text-gray-300 hover:text-[#5856D6] dark:hover:text-[#5856D6] hover:bg-gradient-to-r hover:from-[#5856D6]/8 hover:to-[#AF52DE]/8 dark:hover:from-[#5856D6]/12 dark:hover:to-[#AF52DE]/12 hover: hover:shadow-[#5856D6]/10 active:scale-[0.98]"
                type="button"
              >
                <div
                  class="icon-wrapper w-9 h-9 rounded-xl flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3"
                  style="
                    background: linear-gradient(135deg, #5856d6 0%, #af52de 100%);
                    box-shadow: 0 8px 32px rgba(88, 86, 214, 0.3),
                      inset 0 1px 0 rgba(255, 255, 255, 0.2);
                  "
                >
                  <i
                    class="ri-home-heart-line text-[20px] transition-all duration-300 group-hover:scale-110"
                    style="color: #ffffff; text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2)"
                  ></i>
                </div>
                <span class="title font-medium">{{ directT("sidebar.realEstate") }}</span>
                <i
                  class="ri-arrow-down-s-line text-[16px] ltr:ml-auto rtl:mr-auto transition-transform duration-300 group-hover:text-[#5856D6]"
                  style="color: #9ca3af"
                ></i>
              </button>
              <div class="accordion-collapse hidden mt-2 ltr:ml-12 rtl:mr-12 space-y-1">
                <div class="sidemenu-item">
                  <RouterLink
                    to="/real-estate/property-list"
                    class="submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#5856D6] dark:hover:text-[#5856D6] hover:bg-gradient-to-r hover:from-[#5856D6]/6 hover:to-[#AF52DE]/6 dark:hover:from-[#5856D6]/10 dark:hover:to-[#AF52DE]/10 active:scale-[0.98]"
                    @click="handleNavigation"
                  >
                    <div
                      class="w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3"
                      style="
                        background: linear-gradient(135deg, #5856d6 0%, #af52de 100%);
                      "
                    >
                      <i
                        class="ri-home-line text-[14px] transition-all duration-300"
                        style="color: #ffffff"
                      ></i>
                    </div>
                    <span class="text-sm">{{ directT("sidebar.propertyList") }}</span>
                  </RouterLink>
                </div>
                <div class="sidemenu-item">
                  <RouterLink
                    to="/real-estate/add-property"
                    class="submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#5856D6] dark:hover:text-[#5856D6] hover:bg-gradient-to-r hover:from-[#5856D6]/6 hover:to-[#AF52DE]/6 dark:hover:from-[#5856D6]/10 dark:hover:to-[#AF52DE]/10 active:scale-[0.98]"
                    @click="handleNavigation"
                  >
                    <div
                      class="w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3"
                      style="
                        background: linear-gradient(135deg, #5856d6 0%, #af52de 100%);
                      "
                    >
                      <i
                        class="ri-home-2-line text-[14px] transition-all duration-300"
                        style="color: #ffffff"
                      ></i>
                    </div>
                    <span class="text-sm">{{ directT("sidebar.addProperty") }}</span>
                  </RouterLink>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="section-group">
          <div class="section-header flex items-center mb-4 px-2">
            <div
              class="w-1 h-4 rounded-full ltr:mr-3 rtl:ml-3"
              style="background: linear-gradient(135deg, #ff9500 0%, #ffcc02 100%)"
            ></div>
            <span
              class="font-semibold uppercase text-[11px] tracking-wider"
              style="color: #6b7280"
            >
              {{ directT("sidebar.others") }}
            </span>
          </div>
          <div class="space-y-2">
            <div class="nav-item-container">
              <RouterLink
                to="/members"
                class="nav-item group flex items-center py-3 px-4 rounded-2xl font-medium w-full relative text-gray-700 dark:text-gray-300 hover:text-[#FF9500] dark:hover:text-[#FF9500] hover:bg-gradient-to-r hover:from-[#FF9500]/8 hover:to-[#FFCC02]/8 dark:hover:from-[#FF9500]/12 dark:hover:to-[#FFCC02]/12 hover: hover:shadow-[#FF9500]/10 active:scale-[0.98]"
                @click="handleNavigation"
              >
                <div
                  class="icon-wrapper w-9 h-9 rounded-xl flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3"
                  style="
                    background: linear-gradient(135deg, #ff9500 0%, #ffcc02 100%);
                    box-shadow: 0 8px 32px rgba(255, 149, 0, 0.3),
                      inset 0 1px 0 rgba(255, 255, 255, 0.2);
                  "
                >
                  <i
                    class="ri-group-line text-[20px] transition-all duration-300 group-hover:scale-110"
                    style="color: #ffffff; text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2)"
                  ></i>
                </div>
                <span class="title font-medium">{{ directT("sidebar.members") }}</span>
                <div
                  class="ltr:ml-auto rtl:mr-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                >
                  <div class="w-1.5 h-1.5 rounded-full bg-[#FF9500]"></div>
                </div>
              </RouterLink>
            </div>
            <!-- New Reactive Settings Menu (Real-time Translation) -->
            <div class="nav-item-container">
              <button
                class="nav-item toggle group flex items-center py-3 px-4 rounded-2xl font-medium w-full relative text-gray-700 dark:text-gray-300 hover:text-[#FF9500] dark:hover:text-[#FF9500] hover:bg-gradient-to-r hover:from-[#FF9500]/8 hover:to-[#FFCC02]/8 dark:hover:from-[#FF9500]/12 dark:hover:to-[#FFCC02]/12 hover: hover:shadow-[#FF9500]/10 active:scale-[0.98]"
                :class="{ open: accordionState.settings }"
                type="button"
                @click="toggleAccordionMenu('settings')"
              >
                <div
                  class="icon-wrapper w-9 h-9 rounded-xl flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3"
                  style="
                    background: linear-gradient(135deg, #ff9500 0%, #ffcc02 100%);
                    box-shadow: 0 8px 32px rgba(255, 149, 0, 0.3),
                      inset 0 1px 0 rgba(255, 255, 255, 0.2);
                  "
                >
                  <i
                    class="ri-tools-line text-[20px] transition-all duration-300 group-hover:scale-110"
                    style="color: #ffffff; text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2)"
                  ></i>
                </div>
                <!-- Real-time translated title -->
                <span class="title font-medium">{{ directT("common.settings") }}</span>
                <i
                  class="ri-arrow-down-s-line text-[16px] ltr:ml-auto rtl:mr-auto transition-transform duration-300 group-hover:text-[#FF9500]"
                  :class="{ 'rotate-180': accordionState.settings }"
                  style="color: #9ca3af"
                ></i>
              </button>
              <!-- Reactive sub-menu with v-show for smooth animation -->
              <div
                v-show="accordionState.settings"
                class="accordion-collapse mt-2 ltr:ml-12 rtl:mr-12 space-y-1"
              >

                <div class="sidemenu-item">
                  <RouterLink
                    to="/settings/connections"
                    class="submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#FF9500] dark:hover:text-[#FF9500] hover:bg-gradient-to-r hover:from-[#FF9500]/6 hover:to-[#FFCC02]/6 dark:hover:from-[#FF9500]/10 dark:hover:to-[#FFCC02]/10 active:scale-[0.98]"
                    @click="handleNavigation"
                  >
                    <div
                      class="w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3"
                      style="
                        background: linear-gradient(135deg, #ff9500 0%, #ffcc02 100%);
                      "
                    >
                      <i
                        class="ri-link text-[14px] transition-all duration-300"
                        style="color: #ffffff"
                      ></i>
                    </div>
                    <!-- Real-time translated text -->
                    <span class="text-sm">{{ directT("sidebar.connections") }}</span>
                  </RouterLink>
                </div>
                <div class="sidemenu-item hidden sm:block">
                  <RouterLink
                    to="/settings/leads-settings"
                    class="submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#FF9500] dark:hover:text-[#FF9500] hover:bg-gradient-to-r hover:from-[#FF9500]/6 hover:to-[#FFCC02]/6 dark:hover:from-[#FF9500]/10 dark:hover:to-[#FFCC02]/10 active:scale-[0.98]"
                    @click="handleNavigation"
                  >
                    <div
                      class="w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3"
                      style="
                        background: linear-gradient(135deg, #ff9500 0%, #ffcc02 100%);
                      "
                    >
                      <i
                        class="ri-user-add-line text-[14px] transition-all duration-300"
                        style="color: #ffffff"
                      ></i>
                    </div>
                    <!-- Real-time translated text -->
                    <span class="text-sm">{{ directT("sidebar.leadsSettings") }}</span>
                  </RouterLink>
                </div>
                <div class="sidemenu-item hidden sm:block">
                  <RouterLink
                    to="/settings/customers-settings"
                    class="submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#FF9500] dark:hover:text-[#FF9500] hover:bg-gradient-to-r hover:from-[#FF9500]/6 hover:to-[#FFCC02]/6 dark:hover:from-[#FF9500]/10 dark:hover:to-[#FFCC02]/10 active:scale-[0.98]"
                    @click="handleNavigation"
                  >
                    <div
                      class="w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3"
                      style="
                        background: linear-gradient(135deg, #ff9500 0%, #ffcc02 100%);
                      "
                    >
                      <i
                        class="ri-team-line text-[14px] transition-all duration-300"
                        style="color: #ffffff"
                      ></i>
                    </div>
                    <!-- Real-time translated text -->
                    <span class="text-sm">{{ directT("sidebar.customersSettings") }}</span>
                  </RouterLink>
                </div>
                <div class="sidemenu-item hidden sm:block">
                  <RouterLink
                    to="/settings/deals-settings"
                    class="submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#FF9500] dark:hover:text-[#FF9500] hover:bg-gradient-to-r hover:from-[#FF9500]/6 hover:to-[#FFCC02]/6 dark:hover:from-[#FF9500]/10 dark:hover:to-[#FFCC02]/10 active:scale-[0.98]"
                    @click="handleNavigation"
                  >
                    <div
                      class="w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3"
                      style="
                        background: linear-gradient(135deg, #ff9500 0%, #ffcc02 100%);
                      "
                    >
                      <i
                        class="ri-briefcase-line text-[14px] transition-all duration-300"
                        style="color: #ffffff"
                      ></i>
                    </div>
                    <!-- Real-time translated text -->
                    <span class="text-sm">{{ directT("sidebar.dealsSettings") }}</span>
                  </RouterLink>
                </div>
                <div class="sidemenu-item">
                  <RouterLink
                    to="/settings/account-settings"
                    class="submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#FF9500] dark:hover:text-[#FF9500] hover:bg-gradient-to-r hover:from-[#FF9500]/6 hover:to-[#FFCC02]/6 dark:hover:from-[#FF9500]/10 dark:hover:to-[#FFCC02]/10 active:scale-[0.98]"
                    @click="handleNavigation"
                  >
                    <div
                      class="w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3"
                      style="
                        background: linear-gradient(135deg, #ff9500 0%, #ffcc02 100%);
                      "
                    >
                      <i
                        class="ri-user-settings-line text-[14px] transition-all duration-300"
                        style="color: #ffffff"
                      ></i>
                    </div>
                    <!-- Real-time translated text -->
                    <span class="text-sm">{{ directT("sidebar.accountSettings") }}</span>
                  </RouterLink>
                </div>
                <div class="sidemenu-item">
                  <RouterLink
                    to="/settings/api-settings"
                    class="submenu-item group flex items-center py-2.5 px-4 rounded-xl font-medium w-full relative text-gray-600 dark:text-gray-400 hover:text-[#FF9500] dark:hover:text-[#FF9500] hover:bg-gradient-to-r hover:from-[#FF9500]/6 hover:to-[#FFCC02]/6 dark:hover:from-[#FF9500]/10 dark:hover:to-[#FFCC02]/10 active:scale-[0.98]"
                    @click="handleNavigation"
                  >
                    <div
                      class="w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3"
                      style="
                        background: linear-gradient(135deg, #ff9500 0%, #ffcc02 100%);
                      "
                    >
                      <i
                        class="ri-key-2-line text-[14px] transition-all duration-300"
                        style="color: #ffffff"
                      ></i>
                    </div>
                    <!-- Real-time translated text -->
                    <span class="text-sm">{{ directT("sidebar.apiSettings") }}</span>
                  </RouterLink>
                </div>

              </div>
            </div>
          </div>
        </div>        
        <!-- Account Section -->
        <div class="section-group mt-8">
          <div 
            class="section-header flex items-center mb-4 px-2 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800/50 rounded-lg py-2 transition-colors duration-200"
            @click="toggleSectionCollapse('account')"
          >
            <div
              class="w-1 h-4 rounded-full ltr:mr-3 rtl:ml-3"
              style="background: linear-gradient(to bottom, #ff3b30 0%, #ff6b6b 100%)"
            ></div>
            <span
              class="font-semibold uppercase text-[11px] tracking-wider"
              style="color: #6b7280"
            >
              {{ directT("sidebar.account") }}
            </span>
          </div>
          <div 
            class="section-content space-y-2 transition-all duration-300 ease-in-out overflow-hidden"
            :class="{ 'collapsed': sectionCollapsed.account }"
          >


            <div class="nav-item-container">
              <RouterLink
                to="/authentication/logout"
                class="nav-item group flex items-center py-3 px-4 rounded-2xl font-medium w-full relative text-[#FF3B30] dark:text-[#FF3B30] bg-[#FF3B30]/5 dark:bg-[#FF3B30]/10 border border-[#FF3B30]/10 dark:border-[#FF3B30]/20 hover:bg-gradient-to-r hover:from-[#FF3B30]/8 hover:to-[#FF6B6B]/8 dark:hover:from-[#FF3B30]/12 dark:hover:to-[#FF6B6B]/12 hover: hover:shadow-[#FF3B30]/10 active:scale-[0.98]"
                @click="handleNavigation"
              >
                <div
                  class="icon-wrapper w-9 h-9 rounded-xl flex items-center justify-center transition-all duration-300 ltr:mr-3 rtl:ml-3 border border-[#FF3B30]/20 dark:border-[#FF3B30]/30"
                  style="
                    background: linear-gradient(135deg, #ff3b30 0%, rgb(228, 82, 82) 100%);
                    box-shadow: 0 8px 32px rgba(255, 59, 48, 0.3),
                      inset 0 1px 0 rgba(255, 255, 255, 0.2);
                  "
                >
                  <i
                    class="ri-door-open-line text-[20px] transition-all duration-300 group-hover:scale-110"
                    style="color: #ffffff; text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2)"
                  ></i>
                </div>
                <span
                  class="title font-medium group-hover:text-[#FF6B6B] dark:group-hover:text-[#FF6B6B] transition-colors"
                  >{{ directT("common.logout") }}
                </span>
                <div
                  class="ltr:ml-auto rtl:mr-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div class="w-1.5 h-1.5 rounded-full bg-[#FF3B30]"></div>
                </div>
              </RouterLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  

  <div
    v-if="!stateStoreInstance.open && isMobile() && !isCalendarPage"
    :class="[
      'swipe-indicator fixed top-1/2 -translate-y-1/2 z-[6] h-20 w-1.5 rounded-r-lg transition-opacity ',
      isRTL ? 'right-0' : 'left-0',
    ]"
    style="background: linear-gradient(to bottom, #007aff 0%, #5856d6 100%)"
  ></div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, onBeforeUnmount, computed, watch, nextTick } from "vue";
import { RouterLink, useRouter } from "vue-router";
import stateStore from "@/utils/store";
import enTranslations from "@/i18n/locales/en.json";
import heTranslations from "@/i18n/locales/he.json";
import arTranslations from "@/i18n/locales/ar.json";
import { i18n } from "@/i18n";
import { useUserStore } from "@/store/user";

import emitter from "@/utils/emitter";

type TranslationObject = {
  [key: string]: string | string[] | TranslationObject;
};

const OPEN_MENUS_STORAGE_KEY = "trezo-open-sidebar-menus";

export default defineComponent({
  name: "LeftSidebar",
  setup() {
    const locale = computed(() => i18n.global.locale);
    const router = useRouter();
    const stateStoreInstance = stateStore;
    const sidebarRef = ref<HTMLElement | null>(null);
    const touchStartX = ref(0);
    const touchEndX = ref(0);
    const swipeThreshold = 50;
    const edgeThreshold = 30;
    const forceRerender = ref(0);
    
    // Check if current page is calendar
    const isCalendarPage = computed(() => {
      return router.currentRoute.value.path === '/apps/calendar';
    });

    const openMenus = ref<string[]>([]);

    // New reactive state for accordion management (keeping old logic intact)
    const accordionState = ref<{ [key: string]: boolean }>({
      dashboards: false,
      crm: false,
      ecommerce: false,
      realEstate: false,
      settings: false,
    });

    // Section collapse state for desktop
    const sectionCollapsed = ref<{ [key: string]: boolean }>({
      main: false,
      apps: false,
      aiAgents: false,
      pages: false,
      account: false,
    });

    // Menu items definition with reactive titles
    const menuItems = computed(() => [
      {
        id: "dashboards",
        titleKey: "sidebar.dashboards",
        title: directT("sidebar.dashboards"),
        icon: "ri-pie-chart-2-line",
        gradient: "linear-gradient(135deg, #007AFF 0%, #5856D6 100%)",
        hoverColor: "#007AFF",
        subItems: [
          ...(shouldShowEcommerceDashboard.value
            ? [
                {
                  id: "ecommerce-dashboard",
                  titleKey: "sidebar.ecommerce",
                  title: directT("sidebar.ecommerce"),
                  route: "/dashboard",
                  icon: "ri-shopping-cart-line",
                },
              ]
            : []),
          ...(shouldShowCRMDashboard.value
            ? [
                {
                  id: "crm-dashboard",
                  titleKey: "sidebar.crm",
                  title: directT("sidebar.crm"),
                  route: "/dashboard/crm",
                  icon: "ri-team-line",
                },
              ]
            : []),
        ],
      },
      ...(shouldShowEcommerceMenu.value
        ? [
            {
              id: "ecommerce",
              titleKey: "sidebar.ecommerce",
              title: directT("sidebar.ecommerce"),
              icon: "ri-store-3-line",
              gradient: "linear-gradient(135deg, #5856D6 0%, #AF52DE 100%)",
              hoverColor: "#5856D6",
              subItems: [
                {
                  id: "products-grid",
                  titleKey: "sidebar.productsGrid",
                  title: directT("sidebar.productsGrid"),
                  route: "/ecommerce/products-grid",
                  icon: "ri-grid-line",
                },
                {
                  id: "products-list",
                  titleKey: "sidebar.productsList",
                  title: directT("sidebar.productsList"),
                  route: "/ecommerce/products-list",
                  icon: "ri-list-check",
                },
                {
                  id: "customers",
                  titleKey: "sidebar.customers",
                  title: directT("sidebar.customers"),
                  route: "/crm/customers",
                  icon: "ri-user-line",
                },
                {
                  id: "orders",
                  titleKey: "sidebar.orders",
                  title: directT("sidebar.orders"),
                  route: "/ecommerce/orders",
                  icon: "ri-shopping-bag-line",
                },
              ],
            },
          ]
        : []),
      ...(shouldShowCRMMenu.value
        ? [
            {
              id: "crm",
              titleKey: "sidebar.crm",
              title: directT("sidebar.crm"),
              icon: "ri-user-settings-line",
              gradient: "linear-gradient(135deg, #5856D6 0%, #AF52DE 100%)",
              hoverColor: "#5856D6",
              subItems: [
                {
                  id: "leads",
                  titleKey: "sidebar.leads",
                  title: directT("sidebar.leads"),
                  route: "/crm/leads",
                  icon: "ri-user-add-line",
                },
                {
                  id: "customers",
                  titleKey: "sidebar.customers",
                  title: directT("sidebar.customers"),
                  route: "/crm/customers",
                  icon: "ri-team-line",
                },
                {
                  id: "deals",
                  titleKey: "sidebar.deals",
                  title: directT("sidebar.deals"),
                  route: "/crm/deals",
                  icon: "ri-briefcase-line",
                },
                {
                  id: "products-grid",
                  titleKey: "sidebar.productsGrid",
                  title: directT("sidebar.productsGrid"),
                  route: "/ecommerce/products-grid",
                  icon: "ri-grid-line",
                },
                {
                  id: "products-list",
                  titleKey: "sidebar.productsList",
                  title: directT("sidebar.productsList"),
                  route: "/ecommerce/products-list",
                  icon: "ri-list-check",
                },
              ],
            },
          ]
        : []),
      ...(shouldShowRealEstateMenu.value
        ? [
            {
              id: "realEstate",
              titleKey: "sidebar.realEstate",
              title: directT("sidebar.realEstate"),
              icon: "ri-home-heart-line",
              gradient: "linear-gradient(135deg, #5856D6 0%, #AF52DE 100%)",
              hoverColor: "#5856D6",
              subItems: [
                {
                  id: "property-list",
                  titleKey: "sidebar.propertyList",
                  title: directT("sidebar.propertyList"),
                  route: "/real-estate/property-list",
                  icon: "ri-home-line",
                },
                {
                  id: "add-property",
                  titleKey: "sidebar.addProperty",
                  title: directT("sidebar.addProperty"),
                  route: "/real-estate/add-property",
                  icon: "ri-home-2-line",
                },
              ],
            },
          ]
        : []),
      {
        id: "settings",
        titleKey: "common.settings",
        title: directT("common.settings"),
        icon: "ri-tools-line",
        gradient: "linear-gradient(135deg, #FF9500 0%, #FFCC02 100%)",
        hoverColor: "#FF9500",
        subItems: [
          {
            id: "connections",
            titleKey: "sidebar.connections",
            title: directT("sidebar.connections"),
            route: "/settings/connections",
            icon: "ri-link",
          },
          {
            id: "leads-settings",
            titleKey: "sidebar.leadsSettings",
            title: directT("sidebar.leadsSettings"),
            route: "/settings/leads-settings",
            icon: "ri-user-add-line",
          },
          {
            id: "customers-settings",
            titleKey: "sidebar.customersSettings",
            title: directT("sidebar.customersSettings"),
            route: "/settings/customers-settings",
            icon: "ri-team-line",
          },
          {
            id: "deals-settings",
            titleKey: "sidebar.dealsSettings",
            title: directT("sidebar.dealsSettings"),
            route: "/settings/deals-settings",
            icon: "ri-briefcase-line",
          },
          {
            id: "api-settings",
            titleKey: "sidebar.apiSettings",
            title: directT("sidebar.apiSettings"),
            route: "/settings/api-settings",
            icon: "ri-key-2-line",
          },
        ],
      },
    ]);

    // Section collapse toggle function
    const toggleSectionCollapse = (sectionId: string) => {
      sectionCollapsed.value[sectionId] = !sectionCollapsed.value[sectionId];
    };

    // New reactive accordion functions (keeping old logic for now)
    const toggleAccordionMenu = (menuId: string) => {
      // Close other menus (keeping same UX as before)
      Object.keys(accordionState.value).forEach((key) => {
        if (key !== menuId) {
          accordionState.value[key] = false;
        }
      });

      // Toggle current menu
      accordionState.value[menuId] = !accordionState.value[menuId];

      // Save to localStorage (keeping same logic)
      const openMenuTitles = Object.keys(accordionState.value)
        .filter((key) => accordionState.value[key])
        .map((key) => {
          const menu = menuItems.value.find((m) => m.id === key);
          return menu ? menu.title : key;
        });

      localStorage.setItem(OPEN_MENUS_STORAGE_KEY, JSON.stringify(openMenuTitles));
    };

    // Load accordion state from localStorage (keeping compatibility)
    const loadAccordionStateFromStorage = () => {
      try {
        const savedOpenMenus = localStorage.getItem(OPEN_MENUS_STORAGE_KEY);
        if (savedOpenMenus) {
          const openMenuTitles = JSON.parse(savedOpenMenus);

          // Map saved titles back to menu IDs
          openMenuTitles.forEach((title: string) => {
            const menu = menuItems.value.find((m) => m.title === title);
            if (menu) {
              accordionState.value[menu.id] = true;
            }
          });
        }
      } catch (error) {
        console.error("Error loading accordion state:", error);
        localStorage.removeItem(OPEN_MENUS_STORAGE_KEY);
      }
    };

    const userStore = useUserStore();

    const isRTL = computed(() => document.documentElement.dir === "rtl");

    const translationFiles = {
      en: enTranslations,
      he: heTranslations,
      ar: arTranslations,
    };

    const shouldShowEcommerce = computed(
      () => userStore.organizationSettings.ecommerce === true
    );
    const shouldShowRealEstate = computed(
      () => userStore.organizationSettings.realestate === true
    );

    const shouldShowEcommerceDashboard = computed(() => {
      if (shouldShowRealEstate.value) return false;
      return shouldShowEcommerce.value;
    });

    const shouldShowCRMDashboard = computed(() => {
      if (shouldShowEcommerce.value) return false;
      return true;
    });

    const shouldShowEcommerceMenu = computed(() => {
      if (shouldShowRealEstate.value) return false;
      return shouldShowEcommerce.value;
    });

    const shouldShowCRMMenu = computed(() => {
      // CRM תמיד יוצג, ללא תלות ב-eCommerce
      return true;
    });

    const shouldShowRealEstateMenu = computed(() => {
      if (shouldShowEcommerce.value) return false;
      return shouldShowRealEstate.value;
    });

    // Create a reactive translation function that updates when locale changes
    const translations = computed(() => {
      let currentLocale;

      if (typeof locale.value === "object" && locale.value !== null) {
        currentLocale = String(
          locale.value.value ||
            locale.value.toString() ||
            i18n.global.locale ||
            localStorage.getItem("language") ||
            "en"
        );
      } else {
        currentLocale = String(locale.value);
      }

      if (!["en", "he", "ar"].includes(currentLocale)) {
        currentLocale = "en";
      }

      return translationFiles[currentLocale as keyof typeof translationFiles] || translationFiles.en;
    });

    const directT = (key: string, params?: Record<string, string>): string => {
      const parts = key.split(".");
      let result: TranslationObject | string | string[] = translations.value;

      for (const part of parts) {
        if (
          !result ||
          typeof result === "string" ||
          Array.isArray(result) ||
          !(part in result)
        ) {
          console.warn(`Missing translation key: ${key} in ${locale.value} locale`);
          let enResult: TranslationObject | string | string[] = translationFiles.en;
          for (const fallbackPart of parts) {
            if (
              !enResult ||
              typeof enResult === "string" ||
              Array.isArray(enResult) ||
              !(fallbackPart in enResult)
            )
              return key;
            enResult = enResult[fallbackPart as keyof typeof enResult] as
              | TranslationObject
              | string
              | string[];
          }
          return typeof enResult === "string" ? enResult : key;
        }
        result = result[part as keyof typeof result] as
          | TranslationObject
          | string
          | string[];
      }

      let translatedText: string;
      if (typeof result === "string") {
        translatedText = result;
      } else if (Array.isArray(result)) {
        translatedText = result.join(", "); // Join array elements with comma
      } else {
        translatedText = key; // Return the key if result is not a string or array
      }

      if (params && typeof translatedText === "string") {
        Object.entries(params).forEach(([paramName, paramValue]) => {
          translatedText = translatedText.replace(`{${paramName}}`, paramValue);
        });
      }

      return translatedText;
    };

    const isMobile = () => window.innerWidth < 1280;

    // Mobile touch handling with better debouncing and error prevention
    let touchStartTime = 0;
    let isProcessingTouch = false;
    
    const handleTouchStart = (event: TouchEvent) => {
      // Prevent multiple simultaneous touch events
      if (isProcessingTouch) return;
      
      touchStartTime = Date.now();
      touchStartX.value = event.touches[0].clientX;
    };

    const handleTouchMove = (event: TouchEvent) => {
      // Only process if we have a valid touch start
      if (touchStartTime === 0) return;
      
      touchEndX.value = event.touches[0].clientX;
    };

    const handleTouchEnd = () => {
      // Prevent multiple simultaneous processing
      if (isProcessingTouch || touchStartTime === 0) return;
      
      isProcessingTouch = true;
      
      // Add small delay to prevent conflicts with click events
      setTimeout(() => {
        try {
          if (!isMobile()) {
            isProcessingTouch = false;
            touchStartTime = 0;
            return;
          }

          const swipeDistance = touchEndX.value - touchStartX.value;
          const touchDuration = Date.now() - touchStartTime;
          
          // Only process if touch was quick enough (not a long press)
          if (touchDuration > 1000) {
            isProcessingTouch = false;
            touchStartTime = 0;
            return;
          }

          if (!stateStoreInstance.open) {
            if (
              (!isRTL.value &&
                swipeDistance > swipeThreshold &&
                touchStartX.value < edgeThreshold) ||
              (isRTL.value &&
                swipeDistance < -swipeThreshold &&
                touchStartX.value > window.innerWidth - edgeThreshold)
            ) {
              stateStoreInstance.onChange();
            }
          } else {
            if (
              (!isRTL.value && swipeDistance < -swipeThreshold) ||
              (isRTL.value && swipeDistance > swipeThreshold)
            ) {
              stateStoreInstance.onChange();
            }
          }
        } catch (error) {
          console.warn('Touch handling error:', error);
        } finally {
          isProcessingTouch = false;
          touchStartTime = 0;
        }
      }, 50);
    };

    // Improved click outside handling with better mobile support
    const handleClickOutside = (event: MouseEvent) => {
      if (!isMobile() || !stateStoreInstance.open) return;

      const target = event.target as HTMLElement;
      const burgerMenuBtn = document.querySelector(".hide-sidebar-toggle");

      // Add small delay to prevent conflicts with touch events
      setTimeout(() => {
        if (
          sidebarRef.value &&
          !sidebarRef.value.contains(target) &&
          burgerMenuBtn &&
          !burgerMenuBtn.contains(target)
        ) {
          stateStoreInstance.onChange();
        }
      }, 10);
    };

    const handleNavigation = () => {
      if (isMobile() && stateStoreInstance.open) {
        stateStoreInstance.onChange();
      }
    };

    const closeSidebar = () => {
      console.log("Close sidebar button clicked");
      stateStoreInstance.onChange();
    };

    // Improved router handling with debouncing
    let routerTimeout: ReturnType<typeof setTimeout> | null = null;
    
    router.afterEach(() => {
      if (isMobile() && stateStoreInstance.open) {
        stateStoreInstance.onChange();
      }

      // Clear previous timeout to prevent multiple initializations
      if (routerTimeout) {
        clearTimeout(routerTimeout);
      }
      
      // Debounced accordion initialization
      routerTimeout = setTimeout(() => {
        initializeAccordions();
        routerTimeout = null;
      }, 200);
    });

    const handleLanguageChange = (newLang: string) => {
      console.log(
        `LeftSidebar: Language changed to ${newLang}, reinitializing accordions`
      );

      // Force Vue to re-render the entire sidebar
      forceRerender.value++;
      
      // Force Vue to re-render by triggering a small timeout
      nextTick(() => {
        initializeAccordions();
      });
    };

    // Cleanup function
    const cleanup = () => {
      if (accordionInitTimeout) {
        clearTimeout(accordionInitTimeout);
        accordionInitTimeout = null;
      }
      if (routerTimeout) {
        clearTimeout(routerTimeout);
        routerTimeout = null;
      }
      isInitializingAccordions = false;
      isProcessingTouch = false;
      touchStartTime = 0;
    };

    onMounted(() => {
      // Add event listeners with passive flags where appropriate
      document.addEventListener("click", handleClickOutside);
      document.addEventListener("touchstart", handleTouchStart, { passive: true });
      document.addEventListener("touchmove", handleTouchMove, { passive: true });
      document.addEventListener("touchend", handleTouchEnd, { passive: true });

      // Load new reactive accordion state
      loadAccordionStateFromStorage();

      // Single initialization with proper timing
      nextTick(() => {
        initializeAccordions();
      });

      userStore.fetchOrganizationSettings();

      emitter.on("app:active", handleAppBecameActive);

      watch(locale, (newLocale, oldLocale) => {
        console.log(
          `Language changed from ${oldLocale} to ${newLocale}, reinitializing accordions`
        );
        const newLocaleString =
          typeof newLocale === "object" ? String(newLocale.value) : String(newLocale);
        handleLanguageChange(newLocaleString);
        // Also reload accordion state after language change
        loadAccordionStateFromStorage();
      });

      emitter.on("language:changed", handleLanguageChange);
    });

    onBeforeUnmount(() => {
      // Clean up all resources
      cleanup();
      
      document.removeEventListener("click", handleClickOutside);
      document.removeEventListener("touchstart", handleTouchStart);
      document.removeEventListener("touchmove", handleTouchMove);
      document.removeEventListener("touchend", handleTouchEnd);

      emitter.off("app:active", handleAppBecameActive);
      emitter.off("language:changed", handleLanguageChange);
    });

    const handleAppBecameActive = () => {
      console.log("LeftSidebar: App became active, reinitializing accordions");
      initializeAccordions();
    };

    // Improved accordion initialization with better error handling
    let accordionInitTimeout: ReturnType<typeof setTimeout> | null = null;
    let isInitializingAccordions = false;
    
    const initializeAccordions = () => {
      // Prevent multiple simultaneous initializations
      if (isInitializingAccordions) return;
      
      // Clear any pending initialization
      if (accordionInitTimeout) {
        clearTimeout(accordionInitTimeout);
        accordionInitTimeout = null;
      }
      
      accordionInitTimeout = setTimeout(() => {
        try {
          isInitializingAccordions = true;
          
          // Remove existing event listeners first to prevent duplicates
          const existingAccordions = document.querySelectorAll<HTMLElement>(
            "button.nav-item.toggle"
          );
          
          existingAccordions.forEach((accordion) => {
            // Clone and replace to remove all event listeners
            const newAccordion = accordion.cloneNode(true) as HTMLElement;
            accordion.parentNode?.replaceChild(newAccordion, accordion);
          });

          // Now add fresh event listeners
          const refreshedAccordions = document.querySelectorAll<HTMLElement>(
            "button.nav-item.toggle"
          );

          refreshedAccordions.forEach((accordion) => {
            // Add click handler with better mobile support
            const clickHandler = function(this: HTMLElement, event: Event) {
              // Prevent double-clicks on mobile
              if (isProcessingTouch) {
                event.preventDefault();
                return;
              }
              
              try {
                const siblings = Array.from(
                  this.closest(".accordion-collapse")?.querySelectorAll<HTMLElement>(
                    "button.nav-item.toggle"
                  ) || refreshedAccordions
                );

                siblings.forEach((sibling) => {
                  if (sibling !== this) {
                    sibling.classList.remove("open");
                    const siblingPanel = sibling.nextElementSibling as HTMLElement;
                    if (siblingPanel) {
                      siblingPanel.style.display = "none";
                    }
                  }
                });

                this.classList.toggle("open");
                const panel = this.nextElementSibling as HTMLElement;
                if (panel) {
                  panel.style.display = this.classList.contains("open") ? "block" : "none";
                }

                // Save state with debouncing
                setTimeout(() => {
                  try {
                    const openAccordions = document.querySelectorAll<HTMLElement>(
                      "button.nav-item.toggle.open"
                    );
                    const openMenuTitles = Array.from(openAccordions)
                      .map((acc) => acc.querySelector(".title")?.textContent?.trim())
                      .filter(Boolean);

                    localStorage.setItem(OPEN_MENUS_STORAGE_KEY, JSON.stringify(openMenuTitles));
                  } catch (storageError) {
                    console.warn('Error saving accordion state:', storageError);
                  }
                }, 100);
              } catch (error) {
                console.warn('Accordion click handling error:', error);
              }
            };
            
            // Add the click handler
            accordion.addEventListener("click", clickHandler);
            
            // Add touch-specific handling for better mobile experience
            if (isMobile()) {
              accordion.addEventListener("touchend", (e) => {
                e.preventDefault();
                clickHandler.call(accordion, e);
              }, { passive: false });
            }
          });
        } catch (error) {
          console.warn('Accordion initialization error:', error);
        } finally {
          isInitializingAccordions = false;
          accordionInitTimeout = null;
        }
      }, 50);
    };

    return {
      stateStoreInstance,
      directT,
      translations,
      forceRerender,
      shouldShowEcommerce,
      shouldShowRealEstate,
      shouldShowEcommerceDashboard,
      shouldShowCRMDashboard,
      shouldShowEcommerceMenu,
      shouldShowCRMMenu,
      shouldShowRealEstateMenu,
      sidebarRef,
      handleNavigation,
      isMobile,
      locale,
      isRTL,
      closeSidebar,
      isCalendarPage,
      // New reactive accordion state and functions
      accordionState,
      menuItems,
      toggleAccordionMenu,
      loadAccordionStateFromStorage,
      // Section collapse state and functions
      sectionCollapsed,
      toggleSectionCollapse,
    };
  },
});
</script>

<style scoped>
/* Custom Scrollbar */
.custom-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: rgba(139, 92, 246, 0.3) transparent;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.3), rgba(59, 130, 246, 0.3));
  border-radius: 10px;
  border: 1px solid transparent;
  background-clip: content-box;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.5), rgba(59, 130, 246, 0.5));
  background-clip: content-box;
}

/* Swipe Indicator Animation */
.swipe-indicator {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    opacity: 0.4;
    transform: translateY(-50%) scale(1);
  }
  50% {
    opacity: 0.8;
    transform: translateY(-50%) scale(1.05);
  }
  100% {
    opacity: 0.4;
    transform: translateY(-50%) scale(1);
  }
}

/* Accordion Arrow Animation */
.nav-item.toggle.open .ri-arrow-down-s-line,
.ri-arrow-down-s-line.rotate-180 {
  transform: rotate(180deg);
}

/* Glass Morphism Effects */
.backdrop-blur-xl {
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
}

/* Menu Item Hover Effects */
.nav-item-container:hover {
  transform: translateY(-1px);
}

/* Icon Container Animations */
.nav-item:hover .icon-wrapper {
  transform: scale(1.1);
  transition: all 0.3s ease;
}

/* Icon Glow Effects */
.w-10 {
  position: relative;
  transition: all 0.3s ease;
}

/* Sub-menu Icon Enhanced Animation */
.submenu-item:hover .w-6 {
  transform: scale(1.2);
  transition: all 0.3s ease;
  box-shadow: 0 0 8px rgba(139, 92, 246, 0.4);
}

/* Active Link Styles */
.router-link-active.nav-item,
.router-link-active.submenu-item {
  background: rgba(139, 92, 246, 0.1) !important;
  color: #8b5cf6 !important;
  border-left: 3px solid #8b5cf6;
}

.router-link-active .icon-wrapper {
  background: linear-gradient(135deg, #7c3aed, #3b82f6) !important;
  box-shadow: 0 8px 25px rgba(139, 92, 246, 0.4);
}

.router-link-active .w-6 {
  background: linear-gradient(135deg, #7c3aed, #3b82f6) !important;
  box-shadow: 0 0 12px rgba(139, 92, 246, 0.8);
  transform: scale(1.2);
}

/* Dark Mode Enhancements */
.dark .custom-scrollbar::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.4), rgba(59, 130, 246, 0.4));
  background-clip: content-box;
}

.dark .router-link-active.nav-item,
.dark .router-link-active.submenu-item {
  background: rgba(139, 92, 246, 0.2) !important;
  color: #a78bfa !important;
  border-left: 3px solid #a78bfa;
}

.dark .router-link-active .w-6 {
  background: linear-gradient(135deg, #8b5cf6, #a855f7) !important;
  box-shadow: 0 0 15px rgba(168, 139, 250, 0.6);
}

/* Logo Hover Effect */
.logo .group:hover img {
  filter: drop-shadow(0 0 20px rgba(139, 92, 246, 0.3));
}

/* Responsive Design */
@media (max-width: 1280px) {
  .sidebar-area {
    width: 280px;
  }
}

@media (max-width: 768px) {
  .sidebar-area {
    width: 260px;
  }

  .accordion-button {
    padding: 12px 16px;
  }

  .sidemenu-link {
    padding: 10px 16px;
  }
}

/* Focus States for Accessibility */
.nav-item:focus-visible,
.submenu-item:focus-visible {
  outline: 2px solid #8b5cf6;
  outline-offset: 2px;
  border-radius: 12px;
}

/* Selection */
::selection {
  background: rgba(139, 92, 246, 0.2);
}

.dark ::selection {
  background: rgba(139, 92, 246, 0.3);
}

/* Smooth Transitions */
* {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

/* Sidebar Entrance Animation */
.sidebar-area {
  animation: slideInRight 0.3s ease-out;
}

@keyframes slideInRight {
  from {
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Menu Section Stagger Animation */
.accordion > div:nth-child(1) {
  animation-delay: 0.1s;
}
.accordion > div:nth-child(2) {
  animation-delay: 0.2s;
}
.accordion > div:nth-child(3) {
  animation-delay: 0.3s;
}
.accordion > div:nth-child(4) {
  animation-delay: 0.4s;
}
.accordion > div:nth-child(5) {
  animation-delay: 0.5s;
}

.accordion > div {
  animation: fadeInUp 0.5s ease-out both;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Close Button Hover Effect */
.close-sidebar-btn:hover {
  animation: shake 0.5s ease-in-out;
}

@keyframes shake {
  0%,
  100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-2px);
  }
  75% {
    transform: translateX(2px);
  }
}

/* Section Collapse Animation */
.section-content {
  max-height: 1000px;
  opacity: 1;
}

.section-content.collapsed {
  max-height: 0;
  opacity: 0;
  margin-bottom: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

/* Section Header Hover Effect */
.section-header:hover {
  transform: translateY(-1px);
}

/* Logout Button Special Effect */
a[href="/authentication/logout"].nav-item:hover {
  animation: warningPulse 1s ease-in-out infinite;
}

@keyframes warningPulse {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(255, 59, 48, 0.4);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(255, 59, 48, 0);
  }
}

/* Enhanced Mobile Touch Handling */
@media (max-width: 1279px) {
  .sidebar-area {
    /* Better touch handling */
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    /* Prevent momentum scrolling conflicts */
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
  
  /* Improve touch targets for mobile */
  .nav-item, .submenu-item {
    min-height: 44px; /* iOS recommended touch target size */
    -webkit-tap-highlight-color: rgba(139, 92, 246, 0.1);
    touch-action: manipulation;
    /* Prevent double-tap zoom */
    -webkit-touch-callout: none;
  }
  
  /* Prevent text selection during touch interactions */
  .nav-item, .submenu-item, .close-sidebar-btn {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  
  /* Better button responsiveness */
  .close-sidebar-btn {
    min-width: 44px;
    min-height: 44px;
    -webkit-tap-highlight-color: rgba(139, 92, 246, 0.1);
    touch-action: manipulation;
    /* Faster click response */
    cursor: pointer;
  }
  
  /* Accordion buttons optimized for touch */
  button.nav-item.toggle {
    min-height: 48px;
    padding: 12px 16px;
    -webkit-tap-highlight-color: rgba(139, 92, 246, 0.1);
    touch-action: manipulation;
    /* Prevent text selection */
    -webkit-user-select: none;
    user-select: none;
  }
  
  /* Improve scrolling performance */
  .custom-scrollbar {
    -webkit-overflow-scrolling: touch;
    will-change: scroll-position;
  }
  
  /* Fix for iOS Safari bounce effect */
  .sidebar-area {
    position: fixed;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-y: contain;
  }
}
</style>
